<template>
  <div class="audiorank">
    <sub-title :text="title" />
    <div class="list">
      <div class="item" v-for="(item,index) in list" :key="index" @click="tojump(item)">
        <div class="title">
          {{ item.title | toEllipsisFilter(spl) }}
        </div>
        <div class="between">
          <div class="flex_start">
            <div class="aucove">
              <img :src="item.avatar" alt="" />
            </div>
            <div class="autext">
              <div class="name">{{ item.true_name }}律师</div>
              <div class="time center">
                <img src="~assets/claim/yuyin.png" /> {{item.duration}}
              </div>
            </div>
          </div>

          <div class="num">{{ item.view_num }}人看过</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  props: {
    list: Array,
    title: String,
    num: Number,
    spl: {
      type: Number,
      default: 15,
    },
  },
  beforeMount() {
    console.log(this.list);
  },
  methods:{
    tojump(item) {
      this.$router.push({
        path: "/laws/audioimdet",
        query: {
          audioinId: item.id,
        },
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.audiorank {
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  .list {
    margin-top: 28px;
    .item {
      margin-top: 26px;
      cursor: pointer;
      .title {
        font-size: 16px;
        line-height: 16px;
        color: #333333;
        margin-bottom: 12px;
      }
      .aucove {
        img {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          margin-right: 6px;
        }
      }
      .autext {
        .name {
          font-size: 14px;
          color: #666666;
        }
        .time {
          font-size: 12px;
          color: #999999;
          margin-top: 2px;
          img {
            width: 12px;
            height: 12px;
            margin-right: 12px;
          }
        }
      }
      .num {
        font-size: 12px;
        color: #999999;
      }
      &:hover {
        .title {
          color: #0465ea;
        }
      }
    }
  }
}
</style>